import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import * as fromComponents from './components';
import * as fromContainers from './containers';
import { DgxComponentsButtonModule } from '@domgen/dgx-fe-components/button';

@NgModule({
  declarations: [...fromComponents.components, ...fromContainers.containers],
  imports: [CommonModule, SharedModule, DgxComponentsButtonModule],
  exports: [...fromComponents.components, ...fromContainers.containers],
})
export class CompareModule {}
